// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__ukcKi","item":"PaymentsMobile_item__wusQr","label":"PaymentsMobile_label__3yXi8","amount":"PaymentsMobile_amount__3I5BV"};